(function ($, SCS, debug) {
	'use strict';

	/**
	 * Movie Class
	 */
	function Movie(movieId, callback) {
		debug.log('SCS.TV > Movie > new', movieId, callback);
		this._init(movieId, callback);
	}

	Movie.getPlayerUrl = function(movieId) {
		return SCS.Const.SNOOPY_SHARING_URL + 'L=' + SCS.Const.SNOOPY_LANGUAGE + '&T=VOD&I=' + movieId;
	};

	// class functions
	Movie.prototype = {
		constructor: Movie,


		_init: function (movieId, callback) {
			this.movieId = movieId;
			this.title = '';
			this.price = '';
			this.currency = '';
			this.webavailable = false;
			this.posterUrl = '';
			this.director = '';
			this.country = '';
			this.genre = '';
			this.releaseDate = '';
			this.duration = '';
			this.language = '';

			if (movieId) {
				this._loadData(callback);
			}
		},

		_loadData: function (callback) {
			var movie = this;

			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/vod/' + SCS.Const.SNOOPY_VOD_STORES[SCS.Const.SNOOPY_LANGUAGE] + '/movies/detail/(datalevel=normal;ids=' + this.movieId + ');', function (data) {

				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length === 1) {
					movie._readData(data.Nodes.Items[0]);
				}

				if (typeof callback === 'function') {
					callback(movie);
				}
			});
		},

		_readData: function (movieInfo) {
			this.movieId = movieInfo.Identifier;

			// the poster can be defined by id
			this.posterUrl = (SCS.Const.SNOOPY_IMAGE_BASE ? SCS.Const.SNOOPY_IMAGE_BASE + '/{width}x0' : '/tvairpub/online') + '/content/images/vod/asset/' + this.movieId + '_poster_{size}.jpg';

			// read content data
			if (!movieInfo.Content) {
				return;
			}

			if (movieInfo.Content.Description) {
				this.title = movieInfo.Content.Description.Title;
				this.country = movieInfo.Content.Description.Country;
				this.releaseDate = movieInfo.Content.Description.ReleaseDate ? movieInfo.Content.Description.ReleaseDate.substr(0,4) : '';
			}

			// price has to be read from web availability
			if (!movieInfo.Content.Nodes || !movieInfo.Content.Nodes.Items) {
				return;
			}
			var webVersion = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(movieInfo.Content.Nodes.Items, 'Asset', undefined, 'WEB');
			if (webVersion && webVersion.Availabilities && webVersion.Availabilities.length > 0) {
				var bestAvailability = SCS.TV.Helper.selectCheapestCurrentAvailability(webVersion.Availabilities);
				if (bestAvailability !== null) {
					this.price = bestAvailability.Price;
					this.currency = bestAvailability.Currency;
					this.webavailable = true;
				}
				// get duration from assets in webversion - duration has the following format => PT1H30M3S
				if (webVersion.Content && webVersion.Content.Nodes && webVersion.Content.Nodes.Items) {
					var featuredMovie = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(webVersion.Content.Nodes.Items, 'Video', 'Feature', 'WEB');
					if (featuredMovie && featuredMovie.Content && featuredMovie.Content.Description && featuredMovie.Content.Description.Duration && featuredMovie.Content.Description.Duration.length > 0) {
						this.duration = SCS.TV.Helper.getMinutesFromDurationString(featuredMovie.Content.Description.Duration);
					}
				}
			}

			// get director and gerne from relations
			if (movieInfo.Relations) {
				var genreNode = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(movieInfo.Relations, 'Genre', 'Genre');
				if (genreNode) {
					this.genre = genreNode.TargetIdentifier;
				}

				var directorNode = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(movieInfo.Relations, 'Participant', 'Director');
				if (directorNode && directorNode.TargetNode && directorNode.TargetNode.Content && directorNode.TargetNode.Content.Description) {
					this.director = directorNode.TargetNode.Content.Description.FirstName + ' ' + directorNode.TargetNode.Content.Description.LastName;
				}
			}
		},

		/**
		 * Public API
		 */
		getPosterUrl: function (width) {
			var availableWidth = SCS.TV.Helper.getBestImageWidth(width);
			return this.posterUrl.replace('{size}', 'W' + availableWidth).replace('{width}', width);
		},

		/**
		 * Public API
		 */
		getFormattedPrice: function () {
			if (this.price > 0) {
				var cents = ((this.price - Math.floor(this.price)) * 100);
				if (cents === 0) {
					cents = '00';
				}
				return Math.floor(this.price) + '.' + cents;
			}
			return '0.00';
		},

		/**
		 * Public API
		 */
		getPlayerUrl: function () {
			return SCS.TV.Movie.getPlayerUrl(this.movieId);
		}
	};

	SCS.TV.Movie = Movie;

}(window.jQuery, window.SCS = window.SCS || {}, window.debug));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.Movie.js
// module id = 91
// module chunks = 0